import { render, staticRenderFns } from "./stock-data.vue?vue&type=template&id=e27ddc60&scoped=true&lang=pug"
import script from "./stock-data.vue?vue&type=script&lang=js"
export * from "./stock-data.vue?vue&type=script&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./stock-data.vue?vue&type=style&index=1&id=e27ddc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27ddc60",
  null
  
)

export default component.exports